class Lookup {
  constructor (payload, state, getGroupIndex) {
    this.state = state;
    this.page = payload.info.page;
    this.mode = payload.info.mode;
    this.tab = payload.info.tab;
    this.step = payload.info.step;
    this.name = payload.data.name;
    this.items = payload.data.items;
    this.itemsList = payload.data.itemsList;
    this.itemsTable = payload.data.itemsTable;
    this.headers = payload.data.headers;
    this.values = payload.data.values;
    this.typeLookup = payload.data.typeLookup;
    this.Group = getGroupIndex;

    this.lookupEngine();
  }

  list(field) {
    field.attributes.items = this.itemsList;
  }

  normal(field) {
    field.attributesSelect.items = this.items;
  }

  table(field) {
    field.headers = this.headers;
    field.itemsTable = this.itemsTable;
  }

  gallery(field) {
    field.items = this.values;
  }

  multiselect(field) {
    field.attributesSelect.items = this.items;
  }

  details(field) {
    field.items = JSON.parse(this.values);
  }

  lookupEngine() {
    if (this.tab) {
      let field = this.state.schemes[this.page][this.mode].tabs.content[this.tab].fields.find(f => f.model === this.name);

      if (field) {
        this[this.typeLookup](field);
      } else {
        let index = this.Group(this.state.schemes[this.page][this.mode].tabs.content[this.tab].groups, this.name);
        let fields = this.state.schemes[this.page][this.mode].tabs.content[this.tab].groups[index].fields;
        this[this.typeLookup](fields.find(f => f.model === this.name));
      }
    } else if (this.step) {
      let field = this.state.schemes[this.page][this.mode].steps.content[this.step].fields.find(f => f.model === this.name);

      if (field) {
        this[this.typeLookup](field);
      } else {
        let index = this.Group(this.state.schemes[this.page][this.mode].steps.content[this.step].groups, this.name);
        let fields = this.state.schemes[this.page][this.mode].steps.content[this.step].groups[index].fields;
        this[this.typeLookup](fields.find(f => f.model === this.name));
      }
    } else {
      let field = null;
      let stateSchema = null;

      this.mode == 'master' ? (stateSchema = this.state.schemes[this.page]['form']) : (stateSchema = this.state.schemes[this.page]);

      field = stateSchema[this.mode].fields.find(f => f.model === this.name);

      if (!field) {
        let index = this.Group(stateSchema[this.mode].groups, this.name);

        let fields = stateSchema[this.mode].groups[index].fields;
        this[this.typeLookup](fields.find(f => f.model === this.name));
      }

      if (field) {
        this[this.typeLookup](field);
      }
    }
  }
}

export default Lookup;
